import { render, staticRenderFns } from "./mag_layout.vue?vue&type=template&id=04f31b16&"
import script from "./mag_layout.vue?vue&type=script&lang=js&"
export * from "./mag_layout.vue?vue&type=script&lang=js&"
import style0 from "./_layout.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports